import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ConfirmCFARService {
  busSvcURL = '';
  OBRebookAgent = '';
  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public ConfirmCFAR(
    rebuid: number | undefined,
    ConfirmedItemId: string | undefined
  ): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const cfaritems: JSON = <JSON>(<unknown>{
      BookingId: rebuid,
      ConfirmedItemId: ConfirmedItemId,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'ConfirmCFAR',
      JSON.stringify(cfaritems),
      {
        headers: headers,
      }
    );
  }
}
